import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Button,
  Icon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core';
import { showNotification } from 'redux/actions/ui';
import { useStyles } from './styles';


const FilePreviewTable = ({
  fileData,
  requiredHeaders,
  resetFileData,
  setHeadersError,
  validationResults,
  existingCustomersEmails = new Set()
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const {headers, data} = fileData;
  const emailIndex = headers.indexOf('Email');

  useEffect(() => {
    if (!data.length) {
      dispatch(showNotification('warning', 'Uploaded file data is empty'));
    }

    handleValidateHeaders();
  }, []);

  const handleValidateHeaders = () => {
    const requiredHeadersArr = requiredHeaders.split(',');

    const isHeadersLengthDiff = !(headers.length === requiredHeadersArr.length);
    const isHeadersNamesDiff = headers.some((headerName, i) => requiredHeadersArr[i] !== headerName);

    if (isHeadersLengthDiff || isHeadersNamesDiff) {
      dispatch(
        showNotification(
          'error',
          'Uploaded file headers are wrong. Please check headers according to file template.'
        )
      );
      setHeadersError(true);
    }
  };

  return (
    <div>
      <div className="flex flex-row items-center mb-5">
        <Button
          size="small"
          onClick={resetFileData}
          className="mr-2 border-1-light-grey"
        >
          <Icon fontSize="small">arrow_back</Icon>
        </Button>
        <div className="text-18 font-bold">
          {'Go Back'}
        </div>
      </div>
      <div className="mb-5">
        <TableContainer className="dropzone h-300">
          <Table className={classes.tableRoot}>
            <TableHead>
              <TableRow>
                <TableCell width="60px" align="center">{'#'}</TableCell>
                {headers.map((i) => (
                  <TableCell key={`header-${i}`}>{i}</TableCell>
                ))}
                {validationResults &&
                  <TableCell>Status</TableCell>
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => {
                const rowErrors = validationResults?.[index];
                const errorMsg = rowErrors
                  ? Object.values(rowErrors).join(',\n')
                  : '';
                const isExistingCustomer = !rowErrors
                  && existingCustomersEmails.has(row[emailIndex]?.trim().toLowerCase());

                let rowClassName = '';
                let statusMsg = 'Validated';

                if (rowErrors) {
                  rowClassName = 'text-white bg-error';
                  statusMsg = errorMsg;
                } else if (isExistingCustomer) {
                  rowClassName = 'text-white bg-warning';
                  statusMsg = 'Existing Customer - Will be Updated';
                }

                return (
                  <TableRow key={`row-${index}`}>
                    <TableCell
                      align="right"
                      className={rowClassName}
                      title={errorMsg}
                    >
                      {index + 1}
                    </TableCell>
                    {row.map((cell, i) => (
                      <TableCell
                        key={`row-${index}-cell-${i}`}
                        className={rowClassName}
                      >
                        {cell}
                      </TableCell>
                    ))}
                    {validationResults &&
                      <TableCell
                        className={rowClassName || 'text-green'}
                      >
                        {statusMsg}
                      </TableCell>
                    }
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default FilePreviewTable;
